const CO_OR_NEW = {
  CHANGEOUT: {display: 'Changeout', value: 'Changeout', showOrder: 0, def: false},
  NEW: {display: 'New', value: 'New', showOrder: 1, def: false},
  RELOCATE: {display: 'Relocate', value: 'Relocate', showOrder: 2, def: false},
};

export {CO_OR_NEW};